import { Check } from "lucide-react";
import { PageHero } from "@/components/PageHero";
import { SpeakVideo } from "@/components/SpeakVideo";
import { ASSETS } from "@/lib/assets";
import { SEO } from "@/components/SEO";

export const Forsikring = () => {
  return (
    <>
      <SEO
        title="Kloakpartner for forsikringsselskaber"
        description="Farum Kloak er kloakpartner for forsikringsselskaber. Hurtig respons, konkurrencedygtige priser og klar dokumentation af skadesager – både store og små."
      />
      <PageHero
        eyebrow="Segment · Forsikringsselskaber"
        title={
          <>
            En kloakpartner, <em className="text-[color:var(--fk-gold)]">der holder aftalen.</em>
          </>
        }
        subtitle="Farum Kloak hjælper forsikringsselskaber med hurtig respons, konkurrencedygtige priser og klar dokumentation. Vi løser både de små skadesager og de mere krævende opgaver med en proces, der gør samarbejdet enkelt."
        image={ASSETS.images.insurance}
      />

      {/* Speak Farum video */}
      <section className="border-y border-white/10 bg-[color:var(--fk-bg-2)]">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-28">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-12">
            <div className="md:col-span-5">
              <div className="eyebrow mb-4">Mød holdet</div>
              <h2 className="font-display text-4xl md:text-5xl leading-tight">
                Hvorfor <em className="text-[color:var(--fk-gold)]">Farum Kloak?</em>
              </h2>
            </div>
            <div className="md:col-span-7 flex md:justify-end items-end">
              <p className="text-white/60 font-light max-w-md">
                Få et kort indblik i, hvordan vi arbejder med forsikringssager:
                hurtig afklaring, tydelig kommunikation og dokumentation, der
                gør det nemt at komme videre.
              </p>
            </div>
          </div>
          <SpeakVideo poster={ASSETS.grabs.smilingCrew} testIdSuffix="forsikring" />
        </div>
      </section>

      {/* What we deliver */}
      <section className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-28">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <div className="eyebrow mb-4">Det leverer vi</div>
            <h2 className="font-display text-4xl md:text-5xl leading-tight">
              Klar dokumentation. <em className="text-[color:var(--fk-gold)]">Hurtig håndtering.</em>
            </h2>
          </div>
          <div className="md:col-span-7">
            <ul className="space-y-5">
              {[
                "Hurtig respons og kort vej fra skadesmelding til udførelse",
                "Konkurrencedygtige priser på både mindre opgaver og større skader",
                "Dokumentation klar til skadesbehandling og intern opfølgning",
                "Bred faglighed inden for kloak, rotter, spuling og TV-inspektion",
                "Struktureret afrapportering og enkel administration",
                "Åben kommunikation, klare aftaler og ingen bullshit",
              ].map((b, i) => (
                <li key={i} className="flex gap-4 text-lg text-white/80 font-light border-b border-white/10 pb-5">
                  <Check className="w-5 h-5 flex-shrink-0 mt-1.5 text-[color:var(--fk-gold)]" />
                  <span>{b}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="border-t border-white/10 bg-[color:var(--fk-bg-2)]">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-28 grid grid-cols-1 md:grid-cols-12 gap-10 items-end">
          <div className="md:col-span-7">
            <div className="eyebrow mb-6">Næste skridt</div>
            <h2 className="font-display text-4xl md:text-5xl leading-tight">
              Skal vi tage en <em className="text-[color:var(--fk-gold)]">samarbejdssnak?</em>
            </h2>
            <p className="mt-6 text-white/60 font-light max-w-xl">
              Ring eller send en mail, så tager vi en uforpligtende dialog om
              opgaver, responstid, dokumentation og rammerne for et muligt
              samarbejde.
            </p>
          </div>
          <div className="md:col-span-5 flex flex-col sm:flex-row gap-4">
            <a
              href={ASSETS.brand.phoneTel}
              className="px-7 py-4 text-[11px] tracking-[0.24em] uppercase bg-[color:var(--fk-gold)] text-black hover:bg-[color:var(--fk-gold-hi)] transition-colors text-center"
            >
              Ring {ASSETS.brand.phone}
            </a>
            <a
              href={`mailto:${ASSETS.brand.email}`}
              className="px-7 py-4 text-[11px] tracking-[0.24em] uppercase border border-white/20 hover:border-[color:var(--fk-gold)] hover:text-[color:var(--fk-gold)] transition-colors text-center"
            >
              Send en mail
            </a>
          </div>
        </div>
      </section>
    </>
  );
};
